export const user_pause_max_days = 28;
export const low_ship_est = 5;
export const high_ship_est = 8;
export const short_month_day_format = { month: "short", day: "numeric" };
export const shortmonth_day_year_format = { month: "short", day: "numeric", year: "numeric" };
export const numeric_date_format = { month: "numeric", day: "numeric", year: "numeric" };
export const FLAVOR_STICK_ADDON_COST = 3;
